(() => {
  class SeoFaqsAccordion extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.items = Array.from(this.querySelectorAll('[data-seo-faq-item]'));
      this.items.forEach((item, index) => this.bindItem(item, index === 0));
    }

    bindItem(item, openByDefault) {
      const button = item.querySelector('[data-seo-faq-trigger]');
      if (!button) return;

      if (openByDefault) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      } else {
        item.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
      }

      button.addEventListener('click', () => this.toggle(item, button));
    }

    toggle(item, button) {
      const willOpen = !item.classList.contains('is-open');
      item.classList.toggle('is-open', willOpen);
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }
  }

  // Browsers allow one constructor per custom element name —
  // use distinct subclasses for PLP and PDP tags.
  class SeoPlpFaqs extends SeoFaqsAccordion {}
  class SeoPdpFaqs extends SeoFaqsAccordion {}

  if (!customElements.get('seo-plp-faqs')) {
    customElements.define('seo-plp-faqs', SeoPlpFaqs);
  }

  if (!customElements.get('seo-pdp-faqs')) {
    customElements.define('seo-pdp-faqs', SeoPdpFaqs);
  }
})();
